import React from 'react'
import ResizeObserver from 'resize-observer-polyfill'

import debounce from 'Shared/utils'

import { RESIZE_DELAY } from './constants'
import { getIsSmallScreen } from './utils'

export default function useSmallScreen(): boolean {
	const rootElem = document.getElementById('root')

	const [isSmallScreen, setIsSmallScreen] = React.useState<boolean>(
		getIsSmallScreen(rootElem?.clientWidth || 0)
	)

	const resizeObserverCallback: ResizeObserverCallback = (entries) => {
		const value = getIsSmallScreen(window.innerWidth)

		setIsSmallScreen(value)
	}

	const { current: observer } = React.useRef(
		new ResizeObserver(debounce(resizeObserverCallback, RESIZE_DELAY))
	)

	React.useEffect(() => {
		const element = rootElem

		if (element) {
			observer.observe(element)
		}

		return () => {
			if (!element) {
				return
			}

			observer.unobserve(element)
		}
	}, [rootElem, observer])

	return isSmallScreen
}
